export const buildBasePromptGenerationPrompt = (agentName: string) => `
You are writing a base prompt for an AI agent named "${agentName}".

Generate exactly one polished base prompt that can be used as the system instructions for the agent.

Requirements:
- Write in clear, professional language.
- Define the agent's role, behavior, tone, and output expectations.
- Include practical guidance that helps the agent respond consistently.
- Prefer Markdown formatting with short sections or bullet points when useful.
- Do not explain your reasoning.
- Do not return multiple options.
- Return only the final base prompt text.
`.trim();
